import { Box } from '@mui/material';
import React from 'react';
import { themeColors } from '../../JuvareTheme';
export const FeatureIcons = (props) => {
    return (React.createElement(Box, { sx: {
            pb: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '& svg': { pl: '6px' },
            '& svg:first-of-type': { pl: 0 },
            color: themeColors.icon.disable,
            display: 'flex',
            justifyContent: 'flex-start',
        }, "data-test": 'feature-icons' }, props.children));
};
